export const cities = [
  {
    city: "Dar es Salaam",
    districts: ["Ilala", "Kigamboni", "Kinondoni", "Temeke", "Ubungo"],
  },
  {
    city: "Arusha",
    districts: [
      "Arumeru",
      "Arusha",
      "Longido",
      "Ngorongoro",
      "Monduli",
      "Karatu",
    ],
  },
  {
    city: "Dodoma",
    districts: [
      "Chamwino",
      "Chemba",
      "Dodoma Mjini",
      "Dodoma Vijijini",
      "Kondoa",
      "Kondoa Mjini",
      "Kongwa",
      "Mpwapwa",
      "Bahi",
    ],
  },
  {
    city: "Mwanza",
    districts: [
      "Buchosa",
      "Ilemela",
      "Kwimba",
      "Magu",
      "Misungwi",
      "Nyamagana",
      "Sengerema",
      "Ukerewe",
    ],
  },
  {
    city: "Mbeya",
    districts: [
      "Chunya",
      "Kyela",
      "Mbarali",
      "Mbeya Mjini",
      "Mbeya Vijijini",
      "Rungwe",
    ],
  },
  {
    city: "Morogoro",
    districts: [
      "Gairo",
      "Kilombero",
      "Kilosa",
      "Morogoro Mjini",
      "Morogoro Vijijini",
      "Mvomero",
      "Malinyi",
      "Ulanga",
    ],
  },
  {
    city: "Tanga",
    districts: [
      "Bumbuli",
      "Handeni",
      "Handeni Mjini",
      "Handeni Vijijini",
      "Korogwe",
      "Lushoto",
      "Mkinga",
      "Muheza",
      "Pangani",
      "Tanga",
    ],
  },
  {
    city: "Kahama",
    districts: [],
  },
  {
    city: "Tabora",
    districts: [
      "Igunga",
      "Nzega",
      "Nzega Mjini",
      "Sikonge",
      "Tabora Mjini",
      "Urambo",
      "Uyui",
      "Kaliua",
    ],
  },
  {
    city: "Zanzibar City",
    districts: [],
  },
  {
    city: "Kigoma",
    districts: [
      "Kasulu",
      "Kibondo",
      "Kigoma Vijijini",
      "Kigoma Mjini",
      "Kigoma Ujiji",
      "Buhingwe",
      "Kakonko",
      "Uvinza",
    ],
  },
  {
    city: "Sumbawanga",
    districts: [],
  },
  {
    city: "Kasulu",
    districts: [],
  },
  {
    city: "Songea",
    districts: [],
  },
  {
    city: "Moshi",
    districts: [
      "Hai",
      "Mwanga",
      "Same",
      "Rombo",
      "Moshi Vijijini",
      "Moshi Mjini",
    ],
  },
  {
    city: "Musoma",
    districts: [],
  },
  {
    city: "Shinyanga",
    districts: [
      "Kahama",
      "Kahama Mjini",
      "Kahama Vijijini",
      "Kishapu",
      "Msalala",
      "Shinyanga Mjini",
      "Shinyanga Vijijini",
      "Ushetu",
    ],
  },
  {
    city: "Iringa",
    districts: [
      "Iringa Mjini",
      "Iringa Vijijini",
      "Kilolo",
      "Mafinga Mjini",
      "Mufindi",
    ],
  },
  {
    city: "Singida",
    districts: [
      "Iramba",
      "Manyoni",
      "Singida Mjini",
      "Singida Vijijini",
      "Ikungi",
      "Itigi",
      "Mkalama",
    ],
  },
  {
    city: "Njombe",
    districts: [
      "Ludewa",
      "Makambako",
      "Makete",
      "Njombe Mjini",
      "Njombe Vijijini",
      "Njombe",
      "Wanging'ombe",
      "Makambako Mjini",
    ],
  },
  {
    city: "Bukoba",
    districts: [],
  },
  {
    city: "Kibaha",
    districts: [],
  },
  {
    city: "Mtwara",
    districts: [],
  },
  {
    city: "Mpanda",
    districts: [],
  },
  {
    city: "Tunduma",
    districts: [],
  },
  {
    city: "Makambako",
    districts: [],
  },
  {
    city: "Babati",
    districts: [],
  },
  {
    city: "Handeni",
    districts: [],
  },
  {
    city: "Lindi",
    districts: [],
  },
  {
    city: "Korogwe",
    districts: [],
  },
  {
    city: "Mafinga",
    districts: [],
  },
  {
    city: "Nansio",
    districts: [],
  },
];
